import * as _ from 'lodash';
import { Action } from '@reduxjs/toolkit';

import { UserAccountId } from 'api/UserAccount/model/UserAccountId';
import { UserSessionId } from 'api/UserAccount/model/UserSessionId';
import UnauthenticatedUserSessionModel from 'gen-thrift/unauthenticated_user_session_Model_types';

import { ActionTypes, SignUpAndLoginButtonsActionInterfaces } from './actions';

import { RuntimeException } from 'shared/lib/general/exceptions/RuntimeException';

export interface IUserInfo {
    firstName : string;
    lastName : string;
    emailAddress : string;
    phoneNumber : string | null;
    hasAccessibleRetailers : boolean;
}

export interface ILoggedInUser {
    userInfo : null | IUserInfo;
    authenticatedUserSessionId : UserSessionId;
    userId : UserAccountId;
}

export interface ISignUpAndLoginButtonsState {
    loggedInUser : null | undefined | ILoggedInUser;
    userIconPopoverIsShown : boolean;
    unauthenticatedUserSessionId : UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId | null;
}

const publicSiteInitialState : ISignUpAndLoginButtonsState = {
    loggedInUser: undefined,
    userIconPopoverIsShown: false,
    unauthenticatedUserSessionId: null,
};

const reduceSetUnauthenticatedUserSessionId = (
    state : ISignUpAndLoginButtonsState,
    action : SignUpAndLoginButtonsActionInterfaces.ISetUnauthenticatedUserSessionId
) : ISignUpAndLoginButtonsState => {
    const updates = {
        unauthenticatedUserSessionId : action.payload.unauthenticatedUserSessionId,
    };

    return _.merge({}, state, updates);
};

const reduceSetLoggedInUser = (
    state : ISignUpAndLoginButtonsState,
    action : SignUpAndLoginButtonsActionInterfaces.ISetLoggedInUser
) : ISignUpAndLoginButtonsState => {
    const updates = {
        loggedInUser : action.payload.loggedInUser,
    };

    return _.merge({}, state, updates);
};

const reduceSetLoggedInUserInfo = (
    state : ISignUpAndLoginButtonsState,
    action : SignUpAndLoginButtonsActionInterfaces.ISetLoggedInUserInfo
) : ISignUpAndLoginButtonsState => {

    if ((typeof state.loggedInUser === 'undefined') || state.loggedInUser === null) {
        throw new RuntimeException('loggedInUser unexpectedly not set');
    }

    const updates = {
        loggedInUser : {
            userInfo : action.payload.userInfo,
        }
    };

    return _.merge({}, state, updates);
};

const reduceSetUserIconPopoverIsShown = (
    state : ISignUpAndLoginButtonsState,
    action : SignUpAndLoginButtonsActionInterfaces.ISetUserIconPopoverIsShown
) : ISignUpAndLoginButtonsState => {
    const updates = {
        userIconPopoverIsShown : action.payload.isShown,
    };

    return _.merge({}, state, updates);
};

export const SignUpAndLoginButtonsReducers = (
    state : ISignUpAndLoginButtonsState = publicSiteInitialState,
    action : Action,
) : ISignUpAndLoginButtonsState => {
    switch (action.type) {
        case ActionTypes.SET_UNAUTHENTICATED_USER_SESSION_ID:
            return reduceSetUnauthenticatedUserSessionId(state, action as SignUpAndLoginButtonsActionInterfaces.ISetUnauthenticatedUserSessionId);
        case ActionTypes.SET_LOGGED_IN_USER:
            return reduceSetLoggedInUser(state, action as SignUpAndLoginButtonsActionInterfaces.ISetLoggedInUser);
        case ActionTypes.SET_LOGGED_IN_USER_INFO:
            return reduceSetLoggedInUserInfo(state, action as SignUpAndLoginButtonsActionInterfaces.ISetLoggedInUserInfo);
        case ActionTypes.SET_USER_ICON_POPOVER_IS_SHOWN:
            return reduceSetUserIconPopoverIsShown(state, action as SignUpAndLoginButtonsActionInterfaces.ISetUserIconPopoverIsShown);
        default:
            return state;
    }
};
